<template>
    <header class="subjectHeader">
        <h1 class="subjectTitle">{{subject}}</h1>
    </header>
</template>

<script>
export default {
    props: [
        "subject"
    ]
}
</script>